export default [
    {
        path: '/favoritos',
        name: 'favoritos',
        component: () => import(/* webpackChunkName: "favoritos" */ '../../pages/favoritos').then(m => m.default || m),
        meta: { gtm: 'Favoritos' },
    },
]
